import { confirmAction } from "@/lib/dialogs";

const cleanMessage = (m) => String(m ?? "").replace(/^Value error,\s*/i, "");

export function getFieldErrors(error) {
  const detail = error?.response?.data?.detail;
  if (!Array.isArray(detail)) return {};
  const out = {};
  detail.forEach((d) => {
    const field = Array.isArray(d.loc) ? d.loc[d.loc.length - 1] : "form";
    out[field] = cleanMessage(d.msg);
  });
  return out;
}

/** When the API refuses because a name is already in use, ask whether it is really a different party. True means go ahead. */
export function confirmDuplicate(error) {
  const d = error?.response?.data?.detail;
  if (error?.response?.status === 409 && d && typeof d === "object" && d.code === "DUPLICATE_NAME") {
    return confirmAction({ kind: "warning", title: "This name is already in use", message: d.message, confirmLabel: "Yes, it's different", cancelLabel: "Go back" });
  }
  return Promise.resolve(false);
}

// What kind of failure a message came from, so lib/notify.js can show permission, server and network failures as a dialog
// instead of a passing toast. Keyed by the exact text handed to the toast.
const KINDS = new Map();
export const messageKind = (m) => KINDS.get(m) || null;
const tag = (message, kind) => { KINDS.set(message, kind); return message; };

const TECHNICAL = /sqlalchemy|psycopg|integrityerror|traceback|\bselect\b.*\bfrom\b|\binsert into\b|\bupdate\b.*\bset\b|violates .* constraint|internal server error/i;

export function getErrorMessage(error) {
  const status = error?.response?.status;
  if (error && !error.response && error.request) {
    return tag("We couldn't reach the server. Check your connection and try again.", "network");
  }
  const raw = error?.response?.data?.detail;
  if (status >= 500 || (typeof raw === "string" && TECHNICAL.test(raw))) {
    console.error("Server error (hidden from the user):", raw ?? error);   // the real detail stays in the console and the server log
    return tag("Something went wrong on our side. Please try again. If it keeps happening, tell your administrator.", "server");
  }
  if (status === 403 && typeof raw === "string") return tag(raw, "permission");
  const detail = raw;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail)) return detail.map((d) => `${d.loc?.[d.loc.length - 1]}: ${cleanMessage(d.msg)}`).join("; ");
  return error?.message || "Something went wrong";
}
